import React,{Component} from 'react';
import ReactDOM from 'react-dom';
import {connect} from 'react-redux';
import Carousel from './Carousal';
import {bindActionCreators} from 'redux';
import {withRouter} from "react-router-dom";
import {multipleImageList} from "../../../actions/feedAction";



import Modal from 'react-modal';
 
const customStyles = {
  content : {
    top                   : '50%',
    left                  : '50%',
    right                 : 'auto',
    bottom                : 'auto',
    marginRight           : '-50%',
    transform             : 'translate(-45%, -20%)'
  }
};
 
// Make sure to bind modal to your appElement (http://reactcommunity.org/react-modal/accessibility/)
Modal.setAppElement('#root')
class Imagemodal extends Component {
  constructor(props) {
   
    super(props);
 
    this.state = {
      modalIsOpen   : true,
      selectedIndex : props.currentActiveImage,
      imageList     : []
    };
    this.openModal = this.openModal.bind(this);
    this.afterOpenModal = this.afterOpenModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.fetchImagelist = this.fetchImagelist.bind(this);
  }

  componentDidMount(){
    this.fetchImagelist();
  }
  
  fetchImagelist(){
    let param = {
      feedId : this.props.carousalFeed,
      flag   : ((window.location.href.includes('album') == true) || (window.location.href.includes('album_edit') == true)) ? 'Album' : ''
    };
    this.props.multipleImageList(param)
  }
  openModal(selectedIndex) {
    this.setState({modalIsOpen: true,selectedIndex:selectedIndex});
  }
 
  afterOpenModal() {
    // references are now sync'd and can be accessed.
    this.subtitle.style.color = '#f00';
  }
 
  closeModal() {
    this.setState({modalIsOpen: false});
  }
 
  handleSelect(){
    
  }
  UNSAFE_componentWillReceiveProps(nextProps){
    if(nextProps.imagecarousal != this.props.imagecarousal){
      this.fetchImagelist();
      this.openModal(nextProps.imagecarousal.activeIndex);
    }
    if(nextProps.imagelist != this.props.imagelist){
      this.setState({
        imageList : nextProps.imagelist
      })
    }
  }
  render() {
    return (
      <div className="my-carousal-modal">
       {/*  <button onClick={this.openModal}>Open Modal</button> */}
        <Modal
          isOpen={this.state.modalIsOpen}
          onAfterOpen={this.afterOpenModal}
          onRequestClose={this.closeModal}
          style={customStyles}
          contentLabel=""
        >
 
          <h5 ref={subtitle => this.subtitle = subtitle}>X</h5>
          <button type="button" className="close"><img src="/assets/images/close_btn.png" /></button>
          
            <Carousel 
              currentActiveImage = {this.state.selectedIndex} 
              imageList          = {this.props.position == 'dedicates' ? this.props.media_details : this.state.imageList}
              post_my_reaction   = {this.props.post_my_reaction}
              post_total_reaction= {this.props.post_total_reaction}
              post_total_comment = {this.props.post_total_comment}
              post_total_share   = {this.props.post_total_share}
              feed_id            = {this.props.carousalFeed}
            /> 
        
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    imagecarousal  : state.imagecarousal.imageCarousal,
    imagelist      : state.imagelist.imageList 
  }
}
const mapDispatchToProps = dispatch => {
  return {
    multipleImageList : bindActionCreators(multipleImageList, dispatch),
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(Imagemodal);

 